export default __webpack_public_path__ + "static/media/google.eae9aa93.svg";